<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="60px">
				<el-row>
					<el-col :span="3" v-if="role == 'ad' || role == 'mg'">
						<div style="display:  flex;margin-top:13px; margin-left:5px">
							<el-button type="warning" size="mini" @click="toSaveEx">补签</el-button>
							&nbsp;&nbsp;<el-radio v-model="stype" label="1">按月份</el-radio>
							<el-radio v-model="stype" label="2">按员工</el-radio>
						</div>
					</el-col>
					<el-col :span="3" v-else>
						<div>
							<el-button type="warning" size="mini" @click="toSaveEx">请假/补签</el-button>
						</div>
					</el-col>

					<el-col :span="5">
						<el-form-item label="">
							<el-select size="mini" v-model="searchParams.mth" @change="chgMth()"
								placeholder="请选择">
								<el-option v-for="item in mthList" :key="item" :label="item"
									:value="item">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="5" v-if="role == 'ad' || role == 'mg'">
						<div v-if="stype == '2'" style="display: flex;margin-top:4px; margin-left:10px">
							<el-select size="mini" v-model="searchParams.tid" placeholder="请选员工"
								@change="search()">
								<el-option v-for="(item, id) in stuList" :key="item.id"
									:label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</div>
						<div v-else style="display: flex;margin-top:4px; margin-left:10px">
							<el-select size="mini" v-model="curDateIdx" placeholder="请选择日期"
								@change="search()">
								<el-option v-for="(item, idx) in clzNavi.mthDays" :key="item"
									:label="item" :value="idx">
								</el-option>
							</el-select>
						</div>
					</el-col>
					<el-col :span="1">
						<div>
							<el-button size="mini" @click="clearSearchVal">重置</el-button>
						</div>
					</el-col>
					<el-col :span="10">
						<div class="search-btn" style="display: flex;margin-top:4px">
							出勤：{{ listData.length }}天，<span v-if="lateDays">其中迟到{{ lateDays }}次、</span><span v-if="earlyDays">早退{{ earlyDays
							}}次、</span><span v-if="lateearly">合计{{ lateearly.toFixed(0) }}分钟，</span><span v-if="lateearly">未打卡{{ noChecks }}次。</span>
						</div>
					</el-col>
				</el-row>
			</el-form>
		</div>

		<!-- 考勤数据查询 -->
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData" stripe border height="auto" v-loading="listLoading">
				<el-table-column v-if="stype == '2'" prop="kqdate" label="日期" width="120"></el-table-column>
				<el-table-column v-else prop="userName" label="姓名" width="120"></el-table-column>
				<el-table-column prop="kqdate" label="星期" width="120">
					<template slot-scope="scope">
						{{ showXinqi2(scope.row.kqdate) }}
					</template>
				</el-table-column>

				<el-table-column prop="chkin" label="上班考勤时间" width="120">
					<template slot-scope="scope">
						<el-tag size="mini" :type="scope.row.noLate ? 'success' : 'danger'">
						{{ scope.row.chkin == undefined?'未打卡' : scope.row.chkin}}</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="chkin" label="下班应考勤时间" width="120">
					<template slot-scope="scope">
						<el-tag size="mini" v-if="scope.row.needOutTm" type="info">{{ scope.row.needOutTm }}</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="chkout" label="下班考勤时间" width="120">
					<template slot-scope="scope">
						<el-tag  size="mini" :type="scope.row.noEarly ? 'success' : 'danger'">
							{{ scope.row.chkout ? scope.row.chkout : '未打卡' }}</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="result" label="考勤结果" width="220">
					<template slot-scope="scope">

						<el-tag size="mini" v-if="scope.row.noLate &&  scope.row.noEarly" type="success"> 正常</el-tag>
						<el-tag size="mini" v-else-if="scope.row.result=='正常'" type="success"> 正常</el-tag>
						<div v-else-if="!scope.row.noLate">
                                          <el-tag size="mini" v-if="scope.row.chkin" type="danger"> 迟到</el-tag>
                                          <el-tag size="mini" v-else  type="danger"> 上班未打卡</el-tag>
						</div>
						<div v-else-if="!scope.row.noEarly">
                                          <el-tag size="mini" v-if="scope.row.chkout" type="danger"> 早退</el-tag>
                                          <el-tag size="mini" v-else  type="danger"> 下班未打卡</el-tag>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="feedback" width="140" label="异常反馈"></el-table-column>
				<el-table-column prop="remarks" width="140" label="考勤审批"> </el-table-column>

				<el-table-column prop="cfmdate" label="确认人" >
					<template slot-scope="scope">
						<el-tag size="mini" v-if="scope.row.cfmdate" type="info">{{ scope.row.dbColumn_mder }}</el-tag>
						<el-tag size="mini" v-if="scope.row.cfmdate" type="info">{{ scope.row.cfmdate }}</el-tag>
					</template>
				</el-table-column>

				<el-table-column label="操作" fixed="right" width="200px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button size="mini"  v-show="!scope.row.cfmdate"
								v-if="1" @click="toUpdateEx(scope.$index, scope.row, scope.tid)">反馈
							</el-button>
							<el-button size="mini" v-show="!scope.row.cfmdate"
								v-has-permission-code-and="'002500300000'" v-if="1"
								@click="toUpdate(scope.$index, scope.row)">管理
							</el-button>
							<el-button type="danger" size="mini" v-show="!scope.row.cfmdate"
								v-has-permission-code-and="'002500300005'"
								@click="remove(scope.$index, scope.row)">
								删除
							</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>

		</div>
		<!-- 操作考勤  -->
		<el-dialog title="操作考勤" :visible.sync="dialogCfmVisible" width="30%">
			<div>
				                  <el-radio v-model="isActive" label="迟到">迟到</el-radio>
							<el-radio v-model="isActive" label="早退">早退</el-radio>
							<el-radio v-model="isActive" label="请假">请假</el-radio>
							<el-radio v-model="isActive" label="缺勤">缺勤</el-radio>
							<el-radio v-model="isActive" label="正常">正常</el-radio>
				<br><br>
				<el-input type="textarea" row="3" v-model="activeTxt" placeholder="请填写原由">
				</el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogCfmVisible = false">取 消</el-button>
				<el-button type="primary" @click="mangeKaoqin()">确 定</el-button>
			</div>
		</el-dialog>


		<!-- 异常反馈 -->
		<el-dialog title="异常反馈" :visible.sync="dialogExVisible" width="30%">
			<div>
				<el-input type="textarea" row="3" v-model="feedbackText" placeholder="请填写原由">
				</el-input>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogExVisible = false">取 消</el-button>
				<el-button type="primary" @click="mangeEx()">确 定</el-button>
			</div>
		</el-dialog>

		<editex ref="editEx"></editex>

	</div>
</template>
<script>

import excelUpload from '@/components/biz/fileUpload/excelUpload.vue';
import tapi from '@/api/oa/teacherAttendance.js';
import editex from "./editEx.vue";

export default {
	name: 'attendance',
	components: {
		excelUpload,
		editex
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			dialogVisible: false,
			upsize: '1024',
			qlistdata0: [],//弹窗内的数组
			qlistdata: [], //确认后传入
			dialogUpVisible: false,
			disabled: false,

			title: "",
			id: null,//当前老师
			stuList: [], //老师学生列表
			mth: 0,
			mthList: [], //月份列表

			dialogCfmVisible: false,
			isActive: false,
			activeRow: {},
			activeTxt: "",
			xinqi: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],

			stype: "2",
			curDateIdx: null,
			clzNavi: {},
			role: "",
			dialogExVisible: false,
			feedbackText: "",

			//考勤统计
			lateDays: 0,
			noChecks: 0,
			earlyDays: 0,
			lateearly: 0,

		};
	},
	watch: {
		stype(val) {
			this.searchParams = {}
			if (val == "1") { //按月份
				if (this.mthList && this.mthList.length > 0) {
					this.searchParams.mth = this.mthList[0]
				}
				if (this.clzNavi.mthDays && this.clzNavi.mthDays.length > 0) {
					this.curDateIdx = 0
				}
				this.search()

			} else {//按员工

				//班级列表+月份+当前月份有打卡记录的天
				tapi.listTeachersWithMthes({}, res => {
					this.mthList = res.data.mths
					if (this.mthList && this.mthList.length > 0) {
						this.searchParams.mth = this.mthList[0]
					}
					this.stuList = res.data.teacher
					if (this.stuList && this.stuList.length > 0) {
						this.searchParams.tid = this.stuList[0].id
					}

					this.search()
				});

			}

		}
	},
	methods: {
		chgMth() {
			if (this.stype == 1) {
				this.curDateIdx = 0
			}
			this.search()
		},

		//搜索
		search() {
			this.lateDays = 0
			this.noChecks = 0
			this.earlyDays = 0
			this.lateearly = 0

			tapi.getDays({ mth: this.searchParams.mth }, res => {
				this.clzNavi.mthDays = res.data
				if (this.stype == "1") {

					//   按月份-day
					tapi.listByDays({ day: this.clzNavi.mthDays[this.curDateIdx] }, res => {
						this.listData = res.data;
					})

				} else { // 按员工
					this.listLoading = true;
					tapi.listByTid(this.searchParams, res => {
						let lsDatas = res.data;

						if (lsDatas && lsDatas.length > 0) {
							lsDatas.forEach(v => {
								this.judgeKaoqin(v)    //计算考勤
							})
						}

						this.listData = lsDatas;
						this.listLoading = false;
					})

				}
			})
		},
		showXinqi(str) {
			return new Date(str).getDay()
		}, showXinqi2(str) {
			return this.xinqi[new Date(str).getDay()]
		},

		// 判断上班时间
		judgeKaoqin(one) {

			if (one.chkin) {

				let i = one.chkin.replaceAll(":", "") * 1;
				console.log("one.chkin", one.chkin, "i", i)

				if (i < 93001) {  //10点以后
					one.noLate = 1
				} else {
					if (one.result != '正常') {  //如果人工未判断正常
						one.noLate = 0     //迟到
						this.lateDays += 1;   //迟到天数+1
					} else {
						one.noLate = 1
					}
				}

				let needOutTm = new Date(one.kqdate + " " + one.chkin)

				if (one.noLate == 0) { //需要计算迟到几分钟
					let needInTm = new Date(one.kqdate + " 09:30:00")
					//console.log(" add1 ", (i - 100000))
					this.lateearly += ((needOutTm.getTime() - needInTm.getTime()) / 60000)
				}

				let needOutTmCount = needOutTm.getTime() + 32400000;
				needOutTm.setTime(needOutTmCount)
				one.needOutTm = needOutTm.format('hh:mm:ss')

				//计算下班
				if (one.chkout) {
					let outTm = new Date(one.kqdate + " " + one.chkout)
                               //一分钟内不算早退
					if ((outTm.getTime()+60000) > needOutTmCount) {
						one.noEarly = 1
					} else {

						if (one.result != '正常') {
							one.noEarly = 0
							this.earlyDays += 1;
							console.log(" add2 ", (needOutTmCount - outTm.getTime()) / 60000)
							this.lateearly += ((needOutTmCount - outTm.getTime()) / 60000)
						} else {
							one.noEarly = 1
						}

					}
				} else {
					if (one.result != '正常') {
						this.noChecks += 1;
					} else {

					}

				}
			} else {
				if (one.result != '正常') {
					this.noChecks += 1;
				}
			}

			return one.noLate
		},

		//管理
		toUpdate(index, row) {
			this.dialogCfmVisible = true
			this.activeRow = row
			this.activeTxt = this.activeRow.remarks
		},
		toSaveEx() {
			this.$refs.editEx.open({tid:this.searchParams.tid}, "补签");
		},
		//异常反馈
		toUpdateEx(index, row) {
			this.dialogExVisible = true
			this.activeRow = row
			this.feedbackText = this.activeRow.feedbackText;
		},

		//提交异常原因
		mangeEx() {
			//提交修改考勤
			this.activeRow.feedback = this.feedbackText
			this.activeRow.state = 1
			//提交
			tapi.update(this.activeRow, res => {
				//刷新
				this.search()
				//reset
				this.activeRow = {}
				this.dialogExVisible = false
				this.feedback = ""
				this.isActive = ""
			})
		},

		mangeKaoqin() {
			//提交修改考勤
			this.activeRow.remarks = this.activeTxt
			this.activeRow.state = 2
			this.activeRow.result = this.isActive


			//提交
			tapi.update(this.activeRow, res => {
				console.log(res);
				//刷新

				this.search()

				//reset
				this.activeRow = {}
				this.dialogCfmVisible = false
				this.activeTxt = ""
				this.isActive = ""
			})
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				tapi.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.search();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},

		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};

			this.curDateIdx = null;

			this.lateDays = 0
			this.noChecks = 0
			this.earlyDays = 0
			this.lateearly = 0

			if (this.mthList && this.mthList.length > 0) {
				this.searchParams.mth = this.mthList[0]
			}

			if (this.stuList && this.stuList.length > 0) {
				this.searchParams.tid = this.stuList[0].id
			}
			this.search()
		},

	},
	mounted() {
		//默认是按员工
		tapi.listTeachersWithMthes({}, res => {
			this.mthList = res.data.mths
			if (this.mthList && this.mthList.length > 0) {
				this.searchParams.mth = this.mthList[0]
			}
			this.stuList = res.data.teacher
			if (this.stuList && this.stuList.length > 0) {
				this.searchParams.tid = this.stuList[0].id
			}
			this.search()
		});

		//角色
		let me = this.$caches.user.get();
		this.role = me.role
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
